export const levelColor = {
  INFO: '#00A0AF',
  WARNING: '#e69436',
  ERROR: '#b4433a',
  SUCCESS: '#49a350',
};
